class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.variantSelector  = document.querySelector('variant-selects');
    this.addEventListener('change', debouncedOnChange.bind(this));

    this.cartNoteAccordion = document.querySelector('[data-order-note-title]');
    this.cartNoteAccordionContent = document.querySelector('[data-order-note-content]');
    this.cartNoteAccordion?.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleCartNoteAccordion(); 
    });

    // Close cart note accordion when clicking outside
    this._onDocumentClick = this._onDocumentClick?.bind ? this._onDocumentClick.bind(this) : ((event) => this.handleDocumentClick(event));
    document.addEventListener('click', (event) => this.handleDocumentClick(event));

  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }


  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    // Best effort cleanup in case element is removed
    document.removeEventListener('click', (event) => this.handleDocumentClick(event));
  }

  handleDocumentClick(event) {
    // Only act when drawer is open and accordion is expanded
    if (!this.cartNoteAccordionContent || !this.cartNoteAccordionContent.classList.contains('open')) return;

    const clickTarget = event.target;
    const clickedInsideContent = this.cartNoteAccordionContent.contains(clickTarget);
    const clickedOnTitle = this.cartNoteAccordion && this.cartNoteAccordion.contains(clickTarget);

    if (!clickedInsideContent && !clickedOnTitle) {
      this.cartNoteAccordionContent.classList.remove('open');
    }
  }

  toggleCartNoteAccordion() {
    this.cartNoteAccordionContent.classList.toggle('open');
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }


  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }


        let cartCount = document.querySelector('[data-cart-item-count]');
        if(cartCount) {
          cartCount.innerHTML = parsedState.item_count;
          (parsedState.item_count > 0) ? cartCount.closest('.cart-count-bubble').style.display = '' : cartCount.closest('.cart-count-bubble').style.display = 'none';
        }


        window.cartStrings.cart = parsedState;
        if(this.variantSelector) this.variantSelector.updateQtyNumbers();

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('d-none', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? Utility.trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          Utility.trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          Utility.trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        if (typeof skAnimation === "function") skAnimation();

        // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        console.log(e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('d-none'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        console.error(window.cartStrings.error);
        if(errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.add('disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('d-none'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems?.classList.remove('disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements?.forEach((overlay) => overlay.classList.add('d-none'));
    cartDrawerItemElements?.forEach((overlay) => overlay.classList.add('d-none'));
  }
}

customElements.define('cart-items', CartItems);


if (!customElements.get('shipping-estimator')) {
  customElements.define(
    'shipping-estimator',
    class ShippingEstimator extends HTMLElement {
      constructor() {
        super();
        const that = this;
        this.addEventListener('input', (event) => {
          var inputName = event.target.name;
          if (inputName == 'shipping_address[country]') {
            if (Shopify && Shopify.CountryProvinceSelector) {
              new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                hideElement: 'AddressProvinceContainerNew',
              });
            }
          }
        })
          
        this.addEventListener('submit', (event) => {
          event.preventDefault();
          const formData = new FormData(event.target);
          const params = new URLSearchParams(formData).toString();
          var url = `${event.target.action}?${params}`;
          fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            response.json().then(function (result) {
              if (result?.zip?.length || result?.country?.length || result?.province?.length) {
                var errorHTML = `<ul>`;
                if (result.zip?.length) {errorHTML += `<li class="text-danger">${result.zip[0]}</li>`}
                if (result.country?.length) {errorHTML += `<li class="text-danger">${result.country[0]}</li>`}
                if (result.province?.length) {errorHTML += `<li class="text-danger">${result.province[0]}</li>`}
                errorHTML += `</ul>`;
                that.querySelector('#shippingRates').innerHTML = errorHTML;
              } else if (result.shipping_rates.length) {
                var html = `<ul>`;
                result.shipping_rates.forEach(function (rate) {
                  html += `<li class="shipping-rate">${rate.name} : ${Utility.formatMoney((parseFloat(rate.price)*100), window.money_format)}</li>`;
                })
                html += `</ul>`;
                that.querySelector('#shippingRates').innerHTML = html;
              } else {
                that.querySelector('#shippingRates').innerHTML = window.cartStrings.no_shipping;
              }
            })
          })
        })
      }
    }
  );
}